/**
 * The four paid plans (Q3, R1): ids as the backend catalog and the site handoff (`?plan=`, §6)
 * name them, display order, length in months, and the preselected plan (3 months, R3).
 */
export const PLAN_IDS = ['basic_monthly', 'quarterly', 'semi_annual', 'annual'] as const;

export type PlanId = (typeof PLAN_IDS)[number];

export const DEFAULT_PLAN_ID: PlanId = 'quarterly';

export const PLAN_MONTHS: Readonly<Record<PlanId, number>> = {
  basic_monthly: 1,
  quarterly: 3,
  semi_annual: 6,
  annual: 12,
};

export function isPlanId(value: unknown): value is PlanId {
  return typeof value === 'string' && (PLAN_IDS as readonly string[]).includes(value);
}

/** `?plan=` against the allowlist; null for anything else (the trial is not a plan to buy). */
export function parsePlanId(raw: string | null | undefined): PlanId | null {
  return isPlanId(raw) ? raw : null;
}
